import Auth from "@/components/General/Auth/auth";
import router from "@/router";

export const WatchDogAuth = error => {
  if (typeof error.response !== "undefined" && error.response.status === 401) {
    Auth.logout();
    router.push({ name: "watchDogAuth" });
  }
};
